/**
 * Shifts that qualify for the post-removal “find replacements” manual-invite flow.
 * @param {object|undefined} pattern - A single element from `booking.shiftPattern`.
 */
export function isEligibleReplacementShift(pattern) {
  return (
    pattern?.smartMatchingActiveMode === "replacement" &&
    pattern?.option1 === "replacement" &&
    pattern?.option2 === "manual-invite"
  );
}

/** Replacement flow: automatic smart matching is in progress; skip suggested-worker GETs. */
export function isShiftAutomaticSmartMatchingRunning(pattern) {
  return (
    pattern?.invitedOrSmartMatchingStarted === true ||
    pattern?.hasSmartMatchingRunning === true
  );
}

/** @param {object} data - `smart-matching-started` socket payload */
export function isReplacementSmartMatchingStartedEvent(data, bookingSlug) {
  if (!data || !bookingSlug) return false;
  if (data.bookingSlug !== bookingSlug) return false;
  if (data.smartMatchingActiveMode && data.smartMatchingActiveMode !== "replacement") {
    return false;
  }
  const shiftIndex = Number(data.shiftIndex);
  return !Number.isNaN(shiftIndex);
}

/** @param {object} data - `smart-matching-started` socket payload */
export function patchShiftFromSmartMatchingStartedSocket(data) {
  return {
    invitedOrSmartMatchingStarted:
      data?.invitedOrSmartMatchingStarted ?? true,
    hasSmartMatchingRunning: data?.hasSmartMatchingRunning ?? true,
    smartMatchingActiveMode: data?.smartMatchingActiveMode ?? "replacement",
  };
}
